
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./custom');

let Vue = require('vue').default;
window.Vue = Vue;

import VuePikaday from '@netcz/vue-pikaday';
Vue.use(VuePikaday);

import VueNestable from 'vue-nestable/src';
import nestableHelpers from 'vue-nestable/src';
Vue.use(VueNestable);

import Notifications from './plugins/notifications';
Vue.use(Notifications);

import VueCountdown from '@chenfengyuan/vue-countdown';

Vue.component('user-address-list', require('./components/UserAddressList.vue').default);
Vue.component('user-address-form', require('./components/UserAddressForm.vue').default);
Vue.component('user-profile-form', require('./components/UserProfileForm.vue').default);
Vue.component('checkout-form', require('./components/CheckoutForm.vue').default);
Vue.component('trainings-list', require('./components/TrainingsList.vue').default);
Vue.component('trainings-assistant', require('./components/TrainingsAssistant.vue').default);
Vue.component('faq-list', require('./components/FaqList.vue').default);
Vue.component('training-progress', require('./components/TrainingProgress.vue').default);
Vue.component('training-item-progress', require('./components/TrainingItemProgress.vue').default);
Vue.component('spinner', require('./components/Spinner.vue').default);
Vue.component('basket', require('./components/Basket.vue').default);
Vue.component('password-strength-meter', require('./components/PasswordStrengthMeter.vue').default);
Vue.component('count-badge', require('./components/Badge.vue').default);
Vue.component('mini-watchlist', require('./components/MiniWatchlist.vue').default);
Vue.component('mini-cart', require('./components/MiniCart.vue').default);
Vue.component('cart-flyout', require('./components/CartFlyout.vue').default);
Vue.component('pik-a-day', require('./components/PikadayComponent.vue').default);
Vue.component('discussion-list', require('./components/DiscussionList.vue').default);
Vue.component('discussion-item', require('./components/DiscussionItem.vue').default);
Vue.component('rating-list', require('./components/RatingList.vue').default);
Vue.component('rating-input', require('./components/RatingInput.vue').default);
Vue.component('rating-stars', require('./components/RatingStars.vue').default);
Vue.component('index-rating-stars', require('./components/IndexRatingStars.vue').default);
Vue.component('pagination', require('./components/LaravelVuePagination.vue').default);
Vue.component('training-basket-button', require('./components/TrainingBasketButton.vue').default);
Vue.component('add-to-cart-button', require('./components/AddToCartButton.vue').default);
Vue.component('training-watchlist-button', require('./components/TrainingWatchlistButton.vue').default);
Vue.component('agile', require('./components/Agile.vue').default);
Vue.component('trainings-search', require('./components/TrainingsSearch.vue').default);
Vue.component('videoplayer', require('./components/Videoplayer.vue').default);
Vue.component('newsletter-registration', require('./components/NewsletterRegistration.vue').default);
Vue.component('popup', require('./components/Popup.vue').default);
Vue.component('countdown', VueCountdown);

Vue.filter('str_limit', function (string, value) {
    return string.substring(0, value) + ([...string].length > value ? '...' : '');
});

window.app = new Vue({
    el: '#vue-wrapper',
    comments: true
});

window.storeTrainingBackwardsLink = (url = null) => {
    if (url === null) {
        url = window.location.pathname + window.location.search;
    }
    window.localStorage.setItem('training_backwards_link', url);
};

window.getTrainingBackwardsLink = (defaultValue = '') => {
    let url = window.localStorage.getItem('training_backwards_link');

    if (url === null) {
        url = defaultValue;
    }

    localStorage.removeItem('training_backwards_link');

    return url;
};